import { render } from "./HeroiconsSolidFingerPrint.vue?vue&type=template&id=a4b19d38"
const script = {}

import exportComponent from "/Users/danielarabia/code/rea-nova/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidFingerPrint.vue"]])

export default __exports__